import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface Department {
  _id: string;
  name: string;
  description?: string;
  handbook?: string;
  logo?: string;
  status: "active" | "inactive";
  organization: string;
  members: string[];
  createdAt: string;
  updatedAt: string;
  __v: number;
  userRole?: string;
}

export type DepartmentsResponse = {
  success: boolean;
  data: Department[];
  pagination?: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
  message?: string;
};

const fetchDepartments = async (
  page = 1,
  limit = 20
): Promise<DepartmentsResponse> =>
  (
    await customAxios.get<DepartmentsResponse>(
      `/departments?page=${page}&limit=${limit}`
    )
  ).data;

export const useGetDepartments = (page = 1, limit = 20) =>
  useQuery<DepartmentsResponse, AxiosError>(
    ["departments", page, limit],
    () => fetchDepartments(page, limit),
    {
      onError: (error) =>
        showNotification({
          title: "Error Loading Departments",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load departments",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
